import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ai-editor" }
const _hoisted_2 = { relative: "" }
const _hoisted_3 = { class: "head" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Copy = _resolveComponent("Copy")
  const _component_Popconfirm = _resolveComponent("Popconfirm")
  const _component_MediumEditor = _resolveComponent("MediumEditor")
  const _component_Segment = _resolveComponent("Segment")
  const _component_Loader = _resolveComponent("Loader")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Segment, {
        class: "segment",
        disabled: $props.loading
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Icon, {
                class: "icon",
                icon: "edit-05",
                "stroke-width": "0.8"
              }),
              _cache[10] || (_cache[10] = _createElementVNode("div", null, "Post Editor", -1 /* HOISTED */))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createCommentVNode(" undo "),
              _createVNode(_component_Icon, {
                disabled: !$data.undos.length,
                class: "pointer",
                title: "Undo",
                width: "1.6rem",
                height: "1.6rem",
                stroke: "var(--gray-700)",
                "stroke-width": "1",
                icon: "flip-backward",
                onClick: _cache[0] || (_cache[0] = $event => ($options.onUndo()))
              }, null, 8 /* PROPS */, ["disabled"]),
              _createCommentVNode(" redo "),
              _createVNode(_component_Icon, {
                disabled: !$data.redos.length,
                class: "pointer",
                title: "Redo",
                width: "1.6rem",
                height: "1.6rem",
                stroke: "var(--gray-700)",
                "stroke-width": "1",
                icon: "flip-forward",
                onClick: _cache[1] || (_cache[1] = $event => ($options.onRedo()))
              }, null, 8 /* PROPS */, ["disabled"]),
              _createCommentVNode(" copy "),
              _createVNode(_component_Copy, {
                disabled: !$data.text,
                size: "1.6rem",
                onCopy: _cache[2] || (_cache[2] = $event => ($options.onCopy()))
              }, null, 8 /* PROPS */, ["disabled"]),
              _createCommentVNode("- post to linkedin "),
              ($data.posting || !$data.text )
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    width: "1.4rem",
                    height: "1.4rem",
                    icon: "social/linkedin",
                    disabled: true
                  }))
                : ($data.posted)
                  ? (_openBlock(), _createBlock(_component_Icon, {
                      key: 1,
                      width: "1.4rem",
                      height: "1.4rem",
                      stroke: "var(--success-600)",
                      "stroke-width": "1",
                      icon: "check"
                    }))
                  : (_openBlock(), _createBlock(_component_Popconfirm, {
                      key: 2,
                      width: "max-content",
                      "confirm-button-text": "Yes",
                      "cancel-button-text": "No",
                      title: $options.linkedin_enabled ? 'Post to LinkedIn?' : 'Connect to Linkedin and post?',
                      onConfirm: $data.publish
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Icon, {
                          class: "pointer",
                          width: "1.4rem",
                          height: "1.4rem",
                          icon: "social/linkedin",
                          title: "Post to LinkedIn"
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["title", "onConfirm"])),
              _createCommentVNode(" share "),
              ($options.navigator.share)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 3,
                    disabled: !$data.text,
                    class: "pointer",
                    title: "Share",
                    width: "1.6rem",
                    height: "1.6rem",
                    stroke: "var(--gray-700)",
                    "stroke-width": "1",
                    icon: "share-02",
                    onClick: _cache[3] || (_cache[3] = $event => ($options.share()))
                  }, null, 8 /* PROPS */, ["disabled"]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_MediumEditor, {
              ref: "editor",
              modelValue: $data.text,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.text) = $event)),
              onRefrag: _cache[5] || (_cache[5] = $event => ($options.onRegenerateFragment($event))),
              onUndo: _cache[6] || (_cache[6] = $event => ($options.onUndo())),
              onRedo: _cache[7] || (_cache[7] = $event => ($options.onRedo())),
              onOnLink: _cache[8] || (_cache[8] = $event => ($options.onLink($event))),
              onCopy: _cache[9] || (_cache[9] = $event => ($options.onSelectionCopy($event)))
            }, null, 8 /* PROPS */, ["modelValue"])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"]),
      ($props.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            large: ""
          }))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}